import { z } from 'zod';

import { BaseLoanEvent } from './BaseLoanEvent';

export const NextAmortizationMonthEvent = BaseLoanEvent.extend({
  type: z.literal('nextAmortizationMonth'),
  todayDate: z.date().optional(),
});
export type NextAmortizationMonthEvent = z.infer<typeof NextAmortizationMonthEvent>;
